import {
    USUARI_INICIALITZAR,
    USUARI_OMPLIR_ROLS
} from '../../actions/actionTypes';

const ESTAT_INICIAL = {};

const rols = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_OMPLIR_ROLS:
            return action.rols;

        default:
            return state;
    }
};

export default rols;



// WEBPACK FOOTER //
// ./src/reducers/usuari/rols.js